// extracted by mini-css-extract-plugin
export default {"menuToggle":"SettingsMenu_menuToggle__tl-U4","menu":"SettingsMenu_menu__h6fI-","midSpan":"SettingsMenu_midSpan__nWk81","overlay":"SettingsMenu_overlay__BeEk0"};